import React from 'react';
import { Drawer } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import './AppMobileDrawer.styles.scss';

const drawerSx = {
  '& .MuiDrawer-paper': {
    width: { xs: '300px', sm: '320px' },
    maxWidth: '88vw',
    border: 'none',
    boxShadow: '4px 0 40px rgba(0,0,0,0.18)',
  },
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(4px)',
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
};

const AppMobileDrawer = ({
  navigationItems,
  toggleAppMobileDrawer,
  setToggleAppMobileDrawer,
  openLogModal,
  isUserLoggedIn,
}) => {
  const { pathname } = useLocation();

  const close = () => setToggleAppMobileDrawer(false);

  const isActive = (to) =>
    to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(to + '/');

  const handleLogin = () => {
    close();
    openLogModal?.();
  };

  return (
    <Drawer
      anchor="left"
      open={toggleAppMobileDrawer}
      onClose={close}
      transitionDuration={320}
      ModalProps={{ keepMounted: true }}
      sx={drawerSx}
    >
      <div className="amd-root">

        {/* ── Header ── */}
        <div className="amd-header">
          <div className="amd-header__decor" aria-hidden="true" />
          <div className="amd-header__decor2" aria-hidden="true" />

          <div className="amd-header__inner">
            <div className="amd-header__brand">
              <div className="amd-header__logo">
                <span>OA</span>
              </div>
              <div className="amd-header__text">
                <p className="amd-header__name">Online Applications</p>
                <p className="amd-header__tagline">Gov Services Made Easy</p>
              </div>
            </div>

            <button className="amd-close" onClick={close} aria-label="Close menu">
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </div>

        {/* ── Nav ── */}
        <div className="amd-body">
          <p className="amd-section-label">Navigation</p>
          <nav className="amd-nav">
            {navigationItems.map((item, i) => (
              <Link
                key={i}
                to={item.to}
                className={`amd-nav-item${isActive(item.to) ? ' amd-nav-item--active' : ''}`}
                onClick={close}
              >
                <span className="amd-nav-item__icon-wrap">
                  {item.icon}
                </span>
                <span className="amd-nav-item__label">{item.name}</span>
                <ChevronRightIcon className="amd-nav-item__arrow" fontSize="small" />
              </Link>
            ))}
          </nav>
          {/* Theme toggle removed — dark mode is disabled for now (to be added later). */}
        </div>

        {/* ── Footer ── */}
        <div className="amd-footer">
          {!isUserLoggedIn && (
            <button className="amd-login-btn" onClick={handleLogin}>
              <LoginOutlinedIcon fontSize="small" />
              Sign In / Register
            </button>
          )}
          <p className="amd-footer__copy">
            © {new Date().getFullYear()} Online Applications
          </p>
        </div>

      </div>
    </Drawer>
  );
};

export default AppMobileDrawer;
